import React, { useState, useEffect } from 'react';
import ProductDropdown from '../elements/ProductDropdown';
import BottomSheet from '../components/BottomSheet/BottomSheet2';
import Footer from '../components/footer';
import Header from '../components/header';
import { pdfLink } from '../components/Strings';
import { Link, useNavigate,useParams } from 'react-router-dom';
import { FaSave } from "react-icons/fa";
import ToastCustom from '../components/toast';
const EditFullInvoicePage = () => {
      const { id } = useParams(); // invoice id from URL
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [bookers, setBookers] = useState([]);
  const [routeValue, setRoute] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [location, setLocation] = useState('');
  const [selectedBooker, setSelectedBooker] = useState('');
  const [selectedSupplier, setSelectedSupplier] = useState('');
  const [invoiceProducts, setInvoiceProducts] = useState([]);
  const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
  const [total, setTotal] = useState(0);
  const [received, setReceived] = useState(0);
  const [pending, setPending] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const [routes, setRoutes] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [toastMessage, setToastMessage] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const API_ADD_ROUTE = 'https://app.mirzawaleed.com/addroute.php';
  useEffect(() => {

    const fetchInvoice = async () => {
        console.log("fetching....");
        console.log(id);
      try {
        const res = await fetch(`https://app.mirzawaleed.com/getInvoice.php?id=${id}`);
        const data = await res.json();
        console.log(data);
        if (data.success && data.invoice) {
          const inv = data.invoice;
console.log("yes");
          setSelectedCustomer(inv.customer_id);
          setSelectedBooker(inv.booker);
          setSelectedSupplier(inv.supplier);
          setInputValue(inv.route);
          setReceived(Number(inv.received));
          setPending(Number(inv.pending));
          setTotal(Number(inv.total));
         console.log(data.invoice);
          // products load karo
          setInvoiceProducts(
            inv.products.map((p) => ({
              id: p.id,
              name: p.product,
              variant: p.variant,
              quantity: Number(p.qty),
              price: Number(p.product_price),
              rate: Number(p.rate),
            }))
          );
        }
      } catch (err) {
        console.error("Error fetching invoice:", err);
      }
    };


    const fetchCustomers = async () => {
      try {
        const response = await fetch('https://app.mirzawaleed.com/getCustomers.php');
        const data = await response.json();
        setCustomers(data);
        setFilteredCustomers(data);
      } catch (error) {
        console.error('Error fetching customers:', error);
      }
    };

    const fetchRoutes = async () => {
  try {
    const res = await fetch(`https://app.mirzawaleed.com/getroutes.php`);
    const data = await res.json();
    setRoutes(data || []); // direct data array set karo
    console.log(data);
  } catch (err) {
    console.error("Error fetching routes:", err);
  }
};

    const fetchBookers = async () => {
      try {
        const response = await fetch('https://app.mirzawaleed.com/getBookers.php');
        const data = await response.json();
        setBookers(data);
      } catch (error) {
        console.error('Error fetching bookers:', error);
      }
    };

    const fetchSuppliers = async () => {
      try {
        const response = await fetch('https://app.mirzawaleed.com/getBookers.php');
        const data = await response.json();
        setSuppliers(data);
      } catch (error) {
        console.error('Error fetching suppliers:', error);
      }
    };
    
     fetchInvoice();
    fetchCustomers();
    fetchBookers();
    fetchSuppliers();
    fetchRoutes();
  }, []);





  const handleCustomerChange = (event) => {
    setSelectedCustomer(event.target.value);
  };
const handleInputChange = (e) => {
  const value = e.target.value;
  setInputValue(value);

  if (value.trim() !== "") {
    const filtered = (routes || [])
      .map(r => (typeof r === "string" ? { id: null, name: r } : r))
      .filter(r => (r?.name || "").toLowerCase().includes(value.toLowerCase()));

    setFilteredRoutes(filtered);   // store objects with {id, name}
    setShowSuggestions(filtered.length > 0);
  } else {
    setFilteredRoutes([]);
    setShowSuggestions(false);
  }
};



  // Save new route to DB
  const handleSave = async () => {
   try {
            const response = await fetch(API_ADD_ROUTE, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ name: inputValue, city:"City" }),
            });
            const result = await response.json();
            if (result.success) {
               setToastMessage(`Route Added Successfully`);
               setTimeout(() => setToastMessage(null), 3000);
            } else {
                alert('Error adding route: ' + result.message);
            }
        } catch (error) {
            console.error('Error adding route:', error);
        }
  };

  // When selecting suggestion
  const handleSelectSuggestion = (route) => {
    setInputValue(route);
    setShowSuggestions(false);
  };

  const handleLocationChange = (event) => {
    setLocation(event.target.value);
  };

  const handleBookerChange = (event) => {
    setSelectedBooker(event.target.value);
  };

  const handleSupplierChange = (event) => {
    setSelectedSupplier(event.target.value);
  };
  const handleRouteChange = (event) => {
    setRoute(event.target.value);
  };

  const handleAddProduct = (productsWithVariants) => {
    setInvoiceProducts(prev => {
      const updatedProducts = [...prev, ...productsWithVariants];
      console.log(productsWithVariants);
      const total = updatedProducts.reduce((sum, prod) => 
        sum + (prod.rate * prod.quantity), 0
      );
      setTotal(total);
      setPending(total - received);
      return updatedProducts;
    });
    setBottomSheetOpen(false);
  };

  const handleDeleteProduct = (index) => {
    setInvoiceProducts(prev => {
      const removedProductTotal = prev[index].price * prev[index].quantity;
      const updatedProducts = prev.filter((_, i) => i !== index);
      const total = updatedProducts.reduce((sum, prod) => 
        sum + (prod.rate * prod.quantity), 0
      );
      setTotal(total);
      setPending(total - received);
      return updatedProducts;
    });
  };
        // Helper: case-insensitive match
const normalize = (v) => (v || "").toString().trim().toLowerCase();

const routeExists = routes.some((r) => {
  const name = typeof r === "string" ? r : r?.name;
  return normalize(name) === normalize(inputValue);
});

  const handlePriceChange = (index, event) => {
    const newPrice = parseFloat(event.target.value) || 0;
    setInvoiceProducts(prev => {
      const updatedProducts = [...prev];
      updatedProducts[index].price = newPrice;
      const total = updatedProducts.reduce((sum, prod) => 
        sum + (prod.rate * prod.quantity), 0
      );
      setTotal(total);
      setPending(total - received);
      return updatedProducts;
    });
  };

  const handleQuantityChange = (productIndex, event) => {
    const newQuantity = parseFloat(event.target.value) || 1;
    setInvoiceProducts(prev => {
      const updatedProducts = [...prev];
      updatedProducts[productIndex].quantity = newQuantity;
      const total = updatedProducts.reduce((sum, prod) => 
        sum + (prod.rate * prod.quantity), 0
      );
      setTotal(total);
      setPending(total - received);
      return updatedProducts;
    });
  };

  const handleReceivedChange = (event) => {
    const newReceived = parseFloat(event.target.value) || 0;
    setReceived(newReceived);
    setPending(total - newReceived);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    const filtered = customers.filter(customer =>
      customer.name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setFilteredCustomers(filtered);
  };

  const handleAddProductClick = () => {
    setBottomSheetOpen(true);
  };

  const handleCloseBottomSheet = () => {
    setBottomSheetOpen(false);
  };

  const handleUpdateInvoice = async () => {
    try {
      // Create invoice
      const response = await fetch('https://app.mirzawaleed.com/updateinvoice.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          customer_id: selectedCustomer,
          received,
          pending,
          total,
          booker: selectedBooker,
          supplier: selectedSupplier,
          route: inputValue,
          products: invoiceProducts.map(product => ({
            id: product.id,
            name: product.name,
            variant: product.variant || null,
            variant_id: product.variant_id || null,
            quantity: product.quantity,
            price: product.price,
            rate: product.rate || null
          })),
        }),
      });
      const result = await response.json();
      if (result.success) {
        alert('Invoice created and products saved successfully!');
        window.location.reload(); 
      } else {
        alert('Error creating invoice: ' + (result.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Error creating invoice:', error);
    }
  };

  
  const handlePrintInvoicePdf = (customerId,invoiceId) => {
    const url = `${pdfLink}/printInvoice.php?invoice_id=${invoiceId}&customerId=${customerId}`;
    window.open(url, '_blank');
  };

  return (
    <>
    <Header/>
    {toastMessage && <ToastCustom message={toastMessage} onClose={() => setToastMessage(null)} />}
    <div style={{padding:'8px'}}>
      <br></br>
      <br></br>
      <center><h1>Edit Invoice</h1></center>
      <div>
        <label>Select Customer:</label>
        <input
         type='text'
        placeholder='Search Customer'
        value={searchTerm}
        onChange={handleSearchChange}
        style={{width:'89%',margin:'4px',padding:'4px',fontSize:'14px'}}
        />
        <select value={selectedCustomer} onChange={handleCustomerChange} 
        style={{
          width:'90%',
          padding:'6px',
          margin:'4px'
        }}>
          <option value="">Select Customer</option>
          {filteredCustomers.map((customer) => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
            </option>
          ))}
        </select>
      </div>


      <div>
        <label>Select Booker:</label>
        <select value={selectedBooker} onChange={handleBookerChange} 
        style={{
          width:'90%',
          padding:'6px',
          margin:'4px'
        }}>
          <option value="">Select Booker</option>
          {bookers.map((booker) => (
            <option key={booker.id} value={booker.name}>
              {booker.name}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label>Select Supplier:</label>
        <select value={selectedSupplier} onChange={handleSupplierChange} style={{
          width:'90%',
          padding:'6px',
          margin:'4px'
        }}>
          <option value="">Select Supplier</option>
          {suppliers.map((supplier) => (
            <option key={supplier.id} value={supplier.name}>
              {supplier.name}
            </option>
          ))}
        </select>
      </div>

       <div style={{ position: "relative", width: "300px" }}>
      <label style={{ display: "block", marginBottom: "5px" }}>
        Select Route:
      </label>

      <div style={{ display: "flex", alignItems: "center" }}>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => inputValue && setShowSuggestions(true)}
          style={{
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            width: "100%",
            boxSizing: "border-box",
          }}
        />

{inputValue.trim() !== "" && !routeExists && (
  <button
    onClick={handleSave}
    style={{
      background: "green",
      border: "none",
      padding: "8px",
      cursor: "pointer",
      marginLeft: "5px",
      borderRadius: "4px",
    }}
  >
    <FaSave color="white" />
  </button>
)}

      </div>
      {showSuggestions && filteredRoutes.length > 0 && (
  <ul
    style={{
      position: "absolute",
      background: "white",
      border: "1px solid #ccc",
      width: "100%",
      marginTop: "2px",
      listStyle: "none",
      padding: 0,
      zIndex: 10,
      maxHeight: "150px",
      overflowY: "auto",
    }}
  >
    {filteredRoutes.map((route, index) => {
      const label = typeof route === "string" ? route : route?.name || "";
      return (
        <li
          key={route?.id ?? index}
          onClick={() => handleSelectSuggestion(label)}
          style={{
            padding: "8px",
            cursor: "pointer",
            borderBottom: "1px solid #eee",
          }}
        >
          {label}
        </li>
      );
    })}
  </ul>
)}

</div>

      <div>
        <button onClick={handleAddProductClick} style={{
          width:'90%',
          padding:'6px',
          margin:'4px',
          border:'none',
          outline:'none',
          backgroundColor:'#4b3c7c',color:'white',padding:'12px',borderRadius:'4px'
        }}>Add Product</button>
        
      </div>

      {invoiceProducts.length > 0 && (
            <div style={{ padding: '20px', maxWidth: '1000px', margin: 'auto' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Invoice Products</h2>
            {invoiceProducts.map((product, index) => (
              <div
                key={index}
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  padding: '15px',
                  marginBottom: '15px',
                  backgroundColor: '#fff',
                }}
              >
                <h3 style={{ margin: '0 0 10px', fontSize: '18px', color: '#333' }}>{product.name}</h3>
                <p style={{ margin: '0 0 10px', fontSize: '14px', color: '#555' }}>{product.variant || 'No variant'}</p>
                <div style={{ marginBottom: '10px' }}>
                  <label style={{ display: 'block', fontSize: '14px', color: '#666' }}>Quantity:</label>
                  <input
                    type="number"
                    value={product.quantity}
                    onChange={(e) => handleQuantityChange(index, e)}
                    style={{
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      width: '100%',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <label style={{ display: 'block', fontSize: '14px', color: '#666' }}>Price:</label>
                  <input
                    type="number"
                    value={product.rate}
                    onChange={(e) => handlePriceChange(index, e)}
                    style={{
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      width: '100%',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>
                <button
                  onClick={() => handleDeleteProduct(index)}
                  style={{
                    backgroundColor: '#ff4d4d',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '10px 15px',
                    cursor: 'pointer',
                    fontSize: '14px',
                  }}
                >
                  Delete
                </button>
              </div>
            ))}
          


          <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'start'}}>
          <div style={{margin:'6px',fontSize:'20px',color:'black',padding:'11px',borderRadius:'4px'}}>Total: <span style={{fontSize:'18px'}}>{total}</span></div>
          <div style={{margin:'6px',fontSize:'20px',color:'black',padding:'8px',borderRadius:'4px'}}>Received: 
            <input
              type="number"
              value={received}
              onChange={handleReceivedChange}
              style={{margin:'4px'}}
            />
          </div>
          <div style={{margin:'6px',fontSize:'20px',color:'black',padding:'11px',borderRadius:'4px'}}>Pending: <span style={{fontSize:'18px'}}>{pending}</span></div>
          </div>
        </div>
      )}

      <button onClick={handleUpdateInvoice} style={{
          width:'90%',
          padding:'6px',
          margin:'4px',
          backgroundColor:'#4b3c7c',color:'white',padding:'12px',borderRadius:'4px'
        }}>Update Invoice</button>


        <br></br>
        <br></br>
        <br></br>
        <br></br>
      <BottomSheet open={bottomSheetOpen} onClose={handleCloseBottomSheet}>
        <ProductDropdown onAddProduct={handleAddProduct} />
      </BottomSheet>
    </div>
    <Footer/>
    </>
  );
};

export default EditFullInvoicePage;
